import { EKeyboardKey } from '@/utils/menu.utils';

export type TKeyboardNavigableListKey = EKeyboardKey.Down | EKeyboardKey.End | EKeyboardKey.Home | EKeyboardKey.Up;

interface IGetKeyboardNavigableListTargetIndexParams {
  currentIndex: number;
  isDisabled?: (index: number) => boolean;
  itemCount: number;
  key: TKeyboardNavigableListKey;
  wrap: boolean;
}

export const getKeyboardNavigableListTargetIndex = ({
  currentIndex,
  isDisabled = () => false,
  itemCount,
  key,
  wrap,
}: IGetKeyboardNavigableListTargetIndexParams): number | null => {
  const enabledIndexes = Array.from({ length: itemCount }, (_, index) => index).filter((index) => !isDisabled(index));
  if (!enabledIndexes.length) return null;

  if (key === EKeyboardKey.Home) return enabledIndexes[0];
  if (key === EKeyboardKey.End) return enabledIndexes.at(-1) ?? null;

  const currentPosition = enabledIndexes.indexOf(currentIndex);
  if (currentPosition < 0) return key === EKeyboardKey.Down ? enabledIndexes[0] : (enabledIndexes.at(-1) ?? null);
  if (enabledIndexes.length === 1) return currentIndex;

  const offset = key === EKeyboardKey.Down ? 1 : -1;
  const targetPosition = currentPosition + offset;
  if (targetPosition >= 0 && targetPosition < enabledIndexes.length) return enabledIndexes[targetPosition];
  if (!wrap) return currentIndex;

  return offset > 0 ? enabledIndexes[0] : (enabledIndexes.at(-1) ?? null);
};
